import { render, staticRenderFns } from "./SkillsModal.vue?vue&type=template&id=1769ddca&scoped=true"
import script from "./SkillsModal.vue?vue&type=script&lang=ts"
export * from "./SkillsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1769ddca",
  null
  
)

export default component.exports